import type { SVGProps } from 'react';

export function VolcanoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.4 7.8A2.4 2.4 0 0 1 6 5.4a2.402 2.402 0 0 1 3.945-1.838 2.397 2.397 0 0 1 4.11 0A2.402 2.402 0 0 1 18 5.4 2.402 2.402 0 0 1 14.134 7.3l-1.2 1.8c-.21.311-.559.499-.934.499s-.724-.188-.934-.499l-1.2-1.8A2.4 2.4 0 0 1 8.4 7.8m-.6 7.8 1.815-.908a2.77 2.77 0 0 1 3.195.518l1.219 1.219c.236.236.559.37.892.37.424 0 .818-.21 1.05-.562l.364-.547-2.213-2.486a1.8 1.8 0 0 0-1.346-.604H11.21c-.514 0-1.005.221-1.347.604L7.616 15.73l.176-.131zm.727-3.593A3.6 3.6 0 0 1 11.22 10.8h1.567c1.028 0 2.007.439 2.693 1.207l5.633 6.338a1.959 1.959 0 0 1-1.463 3.259L4.357 21.6A1.96 1.96 0 0 1 2.4 19.642c0-.476.176-.94.495-1.297z" />
    </svg>
  );
}
